/**
 * Helper for converting relative image paths to absolute URLs
 */

import { resolveBackendOrigin } from '../../../Api/apiUrl';

const API_BASE_URL = resolveBackendOrigin(process.env.REACT_APP_API_URL);

/**
 * Converts a relative image path to an absolute URL
 * @param path - Relative path from backend (e.g., "/images/hotels/1/abc.webp")
 * @returns Absolute URL (e.g., "https://localhost:7064/images/hotels/1/abc.webp")
 */
export const getImageUrl = (path: string | null | undefined): string => {
  if (!path) return '';

  // If path is already absolute (starts with http:// or https://), return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Remove leading slash if present (we'll add it back)
  const cleanPath = path.startsWith('/') ? path : `/${path}`;

  // Combine base URL with path
  const absoluteUrl = `${API_BASE_URL}${cleanPath}`;

  console.log('[imageUrlHelper] Converting:', { path, API_BASE_URL, cleanPath, absoluteUrl });

  return absoluteUrl;
};

/**
 * Gets the display URL from ImageDto (tries url first, then filePath)
 * @param imageDto - Image DTO with url and filePath properties
 * @returns Absolute URL for display
 */
export const getImageDisplayUrl = (
  imageDto: { url?: string; filePath?: string } | null | undefined
): string => {
  if (!imageDto) return '';

  const path = imageDto.url || imageDto.filePath;
  return getImageUrl(path);
};
